import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Router } from '@angular/router';
import { UsedSgkz011aService } from '../../../services/used-sgkz011a.service';
import { AuthService } from '../../../services/auth/auth.service';
import { UsedSgkz012aService } from '../../../services/used-sgkz012d.service';
import { LoginUserIdService } from '../../../services/login-user-id.service';

/**
 * 組織兼務選択画面
 * @export
 * @class Sgkz007dComponent
 * @implements {OnInit}
 */
@Component({
  selector: 'app-sgkz007d',
  templateUrl: './sgkz007d.component.html',
  styleUrls: ['./sgkz007d.component.scss']
})
export class Sgkz007dComponent implements OnInit, OnDestroy {

  /** 選択中のユーザID */
  selectedUserId: string | null = null;

  /** ユーザの所属組織一覧 */
  users = [];

  private onDestroy$ = new Subject();

  constructor(
    private router: Router,
    private usedSgkz011aService: UsedSgkz011aService,
    private usedSgkz012aService: UsedSgkz012aService,
    private authService: AuthService,
    private loginUserIdService: LoginUserIdService) { }

  /**
   * 初期処理
   *
   * @memberof Sgkz007dComponent
   */
  ngOnInit(): void {
    this.usedSgkz012aService.soshikiKenmuInfo.pipe(takeUntil(this.onDestroy$)).subscribe(soshikiKenmuInfoList => {
      for (const soshikiKenmuInfo of soshikiKenmuInfoList) {
        this.users.push(
          { id: soshikiKenmuInfo.userId, companyName: soshikiKenmuInfo.companyName, organizationName: soshikiKenmuInfo.organizationName, userName: soshikiKenmuInfo.userName}
        );
      }
    });
  }

  /**
   * 終了処理
   *
   * @memberof Sgkz007dComponent
   */
  ngOnDestroy(): void {
    this.onDestroy$.next();
  }

  /**
   * 選択したユーザで作業管理メニュー画面に遷移する。
   * 
   * @memberof Sgkz007dComponent
   */
  selectUser(): void {
    // ログインユーザIDの管理はサービスで行う。
    this.loginUserIdService.loginUserId = this.selectedUserId;

    this.usedSgkz011aService.isCalledFlag = false;
    this.authService.isCalledFlag = false;

    this.router.navigate(['/sgkz001d']);
  }
}